/**
 * The service to provide app which cannot be migrated to angular.
 * Contains all the methods needed for SharedAjsService.
 * Should migrate all Shared Ajs services when components migrated to angular
 */
import * as UserNotificationActionModal from 'raw-loader!src/app/public/app/shared/userNotifications/user-notifications-actions-modal.html';
export class SharedAjsService {
    /*@ngInject*/
    constructor($q, $http, $filter, $uibModal, modalService, $rootScope, $state, webSocketsService, StorageService, planService, genericServiceAjs, userService) {
        this.$q = $q;
        this.$http = $http;
        this.$filter = $filter;
        this.$uibModal = $uibModal;
        this.modalService = modalService;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.webSocketsService = webSocketsService;
        this.StorageService = StorageService;
        this.planService = planService;
        this.genericServiceAjs = genericServiceAjs;
        this.userService = userService;
        // From Job match service
        // Add to job match service after migrating above modules in constructor
        this.setRefreshJobMatchesListener();
        this.assessmentsSyncMessageListener = this.$q.defer();
    }
    schedulePhoneScreenOrInterview(type, scheduleData, successCallback, errorCallback) {
        let url = '';
        if (type == 'phoneScreen') {
            url = 'api/candidate/schedulephonescreen';
        }
        else if (type == 'interview') {
            url = 'api/candidate/scheduleinterview';
        }
        this.genericServiceAjs.addObject(this.StorageService.get('baseurl') + url, scheduleData).then((data) => {
            successCallback(data);
        }, (error) => {
            errorCallback(error);
        });
    }
    rescheduleMeeting(meetingId, meetingObject, successCallback, errorCallback) {
        this.genericServiceAjs.addObject(this.StorageService.get('baseurl') + 'api/candidate/reschedulemeeting' + '/' + meetingId, meetingObject).then((data) => {
            successCallback(data);
        }, (error) => {
            errorCallback(error);
        });
    }
    //Assessments Sync message
    receiveAssessmentsSyncMessage() {
        return this.assessmentsSyncMessageListener.promise;
    }
    displayAssessmentsSyncMessage(htmlText) {
        this.assessmentsSyncMessageListener.notify(htmlText);
    }
    //shared methods
    onAssociateToJobClick(jobMatch, createJobMatchesObject, candidateName, canAssociateCallback, cannotAssociateCallback) {
        if (jobMatch.showOverride) {
            this._confirmOverrideSuspension(jobMatch, createJobMatchesObject, candidateName, canAssociateCallback, cannotAssociateCallback);
        }
        else if (jobMatch.allowManualMatch) {
            if (canAssociateCallback) {
                canAssociateCallback();
            }
        }
        else {
            this._showBootboxWarning(jobMatch.reasonForNoManualMatch);
        }
    }
    _showBootboxWarning(message) {
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot associate candidate</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }, callback: () => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    }
    _confirmOverrideSuspension(candidate, createJobMatchesObject, candidateName, canAssociateCallback, cannotAssociateCallback) {
        let message = candidate.reasonForNoManualMatch;
        let type = "release";
        let allowOverride = candidate.allowOverride;
        let suspendedMonths = 0;
        let releaseDate = '';
        let releasedJobDetails = {};
        if (candidate.overrideFor === "JOB_LEFT") {
            type = "jobLeft";
            suspendedMonths = candidate.jobLeftDetail.numberOfMonthsToWait;
            releaseDate = this.$filter('fourdotfiveDateFormat')(candidate.jobLeftDetail.leftAt);
            releasedJobDetails = candidate.jobLeftDetail;
        }
        else {
            suspendedMonths = candidate.releasedCandidateDetail.numberOfMonthsToWait;
            releaseDate = this.$filter('fourdotfiveDateFormat')(candidate.releasedCandidateDetail.releasedAt);
            releasedJobDetails = candidate.releasedCandidateDetail;
        }
        let candidateId = releasedJobDetails.candidateId;
        // if(type == 'release') {
        //     message = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
        //     message = message + "Candidate was previously released on '<span class='emerald'>" + $filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' "; 
        //     message = message + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'."
        // } else {
        //     message = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
        //     message = message + "Candidate left previous job on '<span class='emerald'>" + $filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' "; 
        //     message = message + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'."
        // }
        // message = message + "<br>Would you like to override?";
        if (allowOverride) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                message: message,
                className: "zIndex1060",
                backdrop: true,
                onEscape: false,
                buttons: {
                    confirm: {
                        label: 'Override',
                        className: 'btn-info'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    if (result) {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                        let warningModal = this.$uibModal.open({
                            animation: true,
                            ariaLabelledBy: 'modal-title',
                            ariaDescribedBy: 'modal-body',
                            backdrop: 'static',
                            windowClass: 'four-dot-five-modal-medium',
                            templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/associateCandidates/associate-candidates-action-modal.html',
                            backdrop: false,
                            controller: ['$uibModalInstance', 'candidateId', 'candidateName', 'suspendedMonths', 'releaseDate', 'allowOverride', 'releasedJobDetails', 'type', function ($uibModalInstance, candidateId, candidateName, suspendedMonths, releaseDate, allowOverride, releasedJobDetails, type) {
                                    var ctrl = this;
                                    ctrl.candidateId = candidateId;
                                    ctrl.candidateName = candidateName;
                                    ctrl.suspendedMonths = suspendedMonths;
                                    ctrl.releaseDate = releaseDate;
                                    ctrl.allowOverride = allowOverride;
                                    ctrl.recruiterDetails = new OverrideNoteDetail(ctrl.candidateId);
                                    ctrl.releasedJobDetails = releasedJobDetails;
                                    ctrl.type = type;
                                    ctrl.modalTitle = "Override";
                                    ctrl.saveCallback = () => {
                                        if (type === 'release') {
                                            candidate.releasedCandidateDetail.releasedAt = null;
                                        }
                                        else {
                                            candidate.jobLeftDetail.leftAt = null;
                                        }
                                        createJobMatchesObject.overrideNoteDetails.push(ctrl.recruiterDetails);
                                        if (canAssociateCallback) {
                                            canAssociateCallback();
                                        }
                                        $uibModalInstance.close('cancel');
                                    };
                                    ctrl.closeModal = () => {
                                        // vm.removeCandidate(candidate);
                                        if (cannotAssociateCallback) {
                                            cannotAssociateCallback();
                                        }
                                        $uibModalInstance.close('cancel');
                                    };
                                }],
                            controllerAs: 'associateCandidatesActionModal',
                            size: 'md',
                            resolve: {
                                candidateId: () => {
                                    return candidateId;
                                },
                                candidateName: () => {
                                    return candidateName;
                                },
                                suspendedMonths: () => {
                                    return suspendedMonths;
                                },
                                releaseDate: () => {
                                    return releaseDate;
                                },
                                allowOverride: () => {
                                    return allowOverride;
                                },
                                releasedJobDetails: () => {
                                    return releasedJobDetails;
                                },
                                type: () => {
                                    return type;
                                }
                            }
                        });
                    }
                    else {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                }
            });
        }
        else {
            let displayHtmlText = "";
            if (type == 'release') {
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
                displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            else {
                displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
                displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot associate candidate</strong></div>",
                message: displayHtmlText,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    if (cannotAssociateCallback) {
                        cannotAssociateCallback();
                    }
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    }
    setRefreshJobMatchesListener() {
        this.refreshJobMatchesListener = this.$q.defer();
    }
    raiseRefreshJobMatchesEvent(candidateId, jobMatchesActiveTab) {
        this.refreshJobMatchesListener.notify({ candidateId: candidateId, jobMatchesActiveTab: jobMatchesActiveTab });
    }
    receiveRefreshJobMatchesEvent() {
        return this.refreshJobMatchesListener.promise;
    }
    resetRefreshJobMatchesListener() {
        this.refreshJobMatchesListener.resolve();
        this.setRefreshJobMatchesListener();
    }
    // Move to user service after migrating routes
    navigateUserAfterLogin(userObject, loginParamsObject) {
        this.$rootScope.userActive = true;
        let stateObject = {
            loginParamsObject: loginParamsObject
        };
        this.StorageService.set('userDetails', this._createUserDetailsObject(userObject), { 'expires': new Date(Date.now() + this.$rootScope.tokenvalidity) });
        this.$rootScope.userDetails = this.StorageService.get('userDetails');
        if (this.$rootScope.userDetails.roleScreenRef.role.name === '4dot5SuperUser') {
            this.$state.go('missioncontrol.teamMembers');
        }
        else if (this.$rootScope.userDetails.policyChanged) {
            this.$state.go("missioncontrol.changePassword", { message: "Password restrictions have been changed. Please change the password to proceed.", policyChangePasswordUpdate: true });
        }
        else if (this.$rootScope.userDetails.plan.planName == 'Vendor Only') {
            this.$state.go('missioncontrol.requisitions', stateObject, { reload: false });
        }
        else {
            this.$state.go('missioncontrol.dashboard', stateObject, { reload: false });
        }
        this.webSocketsService.connect();
        if (this.$rootScope.userDetails.roleScreenRef.role.name != '4dot5SuperUser') {
            let userCacheObject = {
                userId: this.$rootScope.userDetails.id,
                loggedInCompanyId: this.$rootScope.userDetails.company.companyId
            };
            // Invoke user cache in order to save the users in in-memory-cache.
            this.userService.userCache(userCacheObject, () => { }, (error) => { console.log(error); });
        }
    }
    _setLoginParameters(location) {
        return {
            redirect: location.redirect,
            candidateName: location.cn,
            candidateId: location.c,
            jobMatchId: location.jm,
            candidateType: location.ct,
            jobMatchJobId: location.j,
            isLogin: location.redirect ? true : false
        };
    }
    goToCandidateDocuments(actionType, actionLabel, candidateObj) {
        let windowClass = 'four-dot-five-modal-large';
        if (actionType == 'emailNotification') {
            windowClass = 'four-dot-five-modal-medium';
        }
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: UserNotificationActionModal.default,
            backdrop: 'static',
            keyboard: false,
            controller: ['$uibModalInstance', 'actionType', 'actionLabel', 'documentDtoMap', function ($uibModalInstance, actionType, actionLabel, documentDtoMap) {
                    let vm = this;
                    this.actionType = actionType;
                    this.actionLabel = actionLabel;
                    this.documentDtoMap = documentDtoMap;
                    this.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                }],
            windowTopClass: windowClass,
            controllerAs: 'userNotificationsActionModal',
            size: 'lg',
            resolve: {
                actionType: () => {
                    return actionType;
                },
                actionLabel: () => {
                    return actionLabel;
                },
                documentDtoMap: () => {
                    return candidateObj;
                }
            }
        });
    }
    viewDocumentFIle(file, successCallback, errorCallback) {
        let actionType = 'viewDocument';
        let actionLabel = file.fileName ? file.fileName : 'Document';
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        let viewDocumentFileModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            windowTopClass: 'four-dot-five-modal-large',
            component: 'candidateProfileActionsModal',
            resolve: {
                actionType: () => {
                    return actionType;
                },
                actionLabel: () => {
                    return actionLabel;
                },
                document: () => {
                    return file;
                }
            }
        });
        viewDocumentFileModal.result.then((callbackObject) => {
            if (successCallback) {
                successCallback(callbackObject);
            }
        }, (dismiss) => {
            if (errorCallback) {
                errorCallback(dismiss);
            }
        });
    }
    _createUserDetailsObject(data) {
        let obj = {};
        obj.company = {};
        obj.plan = {};
        obj.id = data.id;
        obj.firstname = data.firstname;
        obj.lastname = data.lastname;
        obj.emailId = data.emailId;
        obj.companyId = data.companyId;
        obj.policyChanged = data.policyChanged;
        // obj.accesstoken = data.token;
        obj.company.companyId = data.company.companyId;
        obj.company.companyName = data.company.companyName;
        obj.company.companyType = data.company.companyType;
        obj.company.companyState = data.company.companyState;
        obj.company.companyStateLabel = data.company.companyState == 'SoftHold' ? 'Soft Hold' : data.company.companyState;
        obj.company.message = data.company.message;
        obj.plan.planName = data.planMinDto.planName;
        obj.plan.planType = data.planMinDto.planType;
        obj.plan.startDate = moment(data.planMinDto.planStartDate);
        obj.plan.endDate = moment(data.planMinDto.planEndDate);
        obj.plan.message = this.planService.getPlanExpiryMessage(obj.plan.planType, obj.plan.endDate, true);
        ;
        obj.accountState = data.accountState;
        obj.shouldPopupBeDisplayed = data.shouldPopupBeDisplayed;
        obj.roleScreenRef = this._createRoleScreenRefObj(data.roleScreenRef);
        if (data.roleScreenRef.role.name !== '4dot5SuperUser' && data.roleScreenRef.role.name !== '4dot5Admin') {
            obj.company.companySelected = true;
        }
        else {
            obj.company.companySelected = false;
        }
        return obj;
    }
    _createRoleScreenRefObj(roleScreenRef) {
        let roleObj = {};
        roleObj.role = {};
        roleObj.role.id = roleScreenRef.role.id;
        roleObj.role.name = roleScreenRef.role.name;
        roleObj.screen = this._manageScreenListForRoles(roleScreenRef.screen);
        return roleObj;
    }
    _manageScreenListForRoles(screenlist) {
        for (let i = 0; i < screenlist.length; i++) {
            delete screenlist[i].name;
        }
        return screenlist;
    }
    navigateToHomeScreen(loginParamsObject) {
        let stateObject = {
            loginParamsObject: loginParamsObject
        };
        if (this.$rootScope.userDetails.roleScreenRef.role.name === '4dot5SuperUser' && this.$rootScope.userDetails.company.companyType == "Host") {
            this.$state.go('missioncontrol.teamMembers');
        }
        else if (this.$rootScope.userDetails.policyChanged) {
            this.$state.go("missioncontrol.changePassword", { message: "Password restrictions have been changed. Please change the password to proceed.", policyChangePasswordUpdate: true });
        }
        else if (this.$rootScope.userDetails.plan.planName == 'Vendor Only') {
            this.$state.go('missioncontrol.requisitions', stateObject, { reload: false });
        }
        else {
            this.$state.go('missioncontrol.dashboard', stateObject, { reload: false });
        }
    }
}
//# sourceMappingURL=sharedAjsService.js.map